import { autoserialize } from 'cerialize';

export class DonationItem implements IDonationItem {
  @autoserialize id: string;
  @autoserialize type: 'CustomItem' | 'Item';
  @autoserialize source_item_id: string;
  @autoserialize name: string;
  @autoserialize description_preview: string;
  @autoserialize description: string;
  @autoserialize icon_url: string;
  @autoserialize xlarge: number;
  @autoserialize large: number;
  @autoserialize medium: number;
  @autoserialize small: number;
  @autoserialize recycling: number;
  @autoserialize item_recycling: number;
  @autoserialize specialty: number;
  @autoserialize disassembly: number;
  @autoserialize restricted: boolean;
  @autoserialize guaranteed: boolean;
  @autoserialize price: number;
  @autoserialize item_value: number;
  @autoserialize value: number;

  constructor(payload?: IDonationItem) {
    this.id = payload?.id?.toString();
    this.type = payload?.type;
    this.source_item_id = payload?.source_item_id?.toString();
    this.name = payload?.name;
    this.description = payload?.description;
    this.description_preview = payload?.description_preview;
    this.icon_url = payload?.icon_url;
    this.xlarge = payload?.xlarge ?? 0;
    this.large = payload?.large ?? 0;
    this.medium = payload?.medium ?? 0;
    this.small = payload?.small ?? 0;
    this.recycling = payload?.recycling ?? 0;
    this.item_recycling = payload?.item_recycling ?? 0;
    this.specialty = payload?.specialty ?? 0;
    this.disassembly = payload?.disassembly ?? 0;
    this.restricted = payload?.restricted;
    this.guaranteed = payload?.guaranteed;
    this.price = payload?.price;
    this.item_value = payload?.item_value ?? 0;
    this.value = payload?.value ?? 0;
  }

  get size(): string {
    if (this.xlarge > 0) return 'xlarge';
    if (this.large > 0) return 'large';
    if (this.medium > 0) return 'medium';
    if (this.small > 0) return 'small';
    return 'Unknown';
  }
}

export interface IDonationItem {
  id: string;
  type?: 'CustomItem' | 'Item';
  source_item_id?: string;
  name?: string;
  description?: string;
  description_preview?: string;
  icon_url?: string;
  size?: string;
  xlarge?: number;
  large?: number;
  medium?: number;
  small?: number;
  recycling?: number;
  item_recycling?: number;
  specialty?: number;
  disassembly?: number;
  restricted?: boolean;
  guaranteed?: boolean;
  price?: number;
  item_value?: number;
  value?: number;
  count?: number;
}

export const sizeDescriptions = {
  xlarge: '2+ person lift / special equipment',
  large: '2-person lift',
  medium: '1-person lift',
  small: '1-person lift',
};
